import moment from 'moment'

function getHasBonus(userType, date) {
  return (
    userType.is_bonus &&
    moment(date).format('YYYY-MM') >= moment(userType.start_bonus_date).format('YYYY-MM')
  )
}

export default getHasBonus